import { create } from 'zustand'

type StepNavState = {
  nextDisabled: boolean
  backDisabled: boolean
  nextLoading: boolean
  progressBarStep: number
  readonly totalNumberSteps: number
}

type StepNavActions = {
  setNextDisabled: (nextDisabled: boolean) => void
  setBackDisabled: (backDisabled: boolean) => void
  setNextLoading: (nextLoading: boolean) => void
  setStepNavDisabled: (disabled: boolean) => void
  setProgressBarStep: (stepNumber: number) => void
}

export const useStepNavStore = create<StepNavActions & StepNavState>()((set) => ({
  nextDisabled: false,
  backDisabled: false,
  nextLoading: false,
  progressBarStep: 1,
  totalNumberSteps: 4,
  setNextDisabled: (nextDisabled) => set({ nextDisabled }),
  setBackDisabled: (backDisabled) => set({ backDisabled }),
  setNextLoading: (nextLoading) => set({ nextLoading, nextDisabled: nextLoading, backDisabled: nextLoading }),
  setStepNavDisabled: (disabled) => set({ nextDisabled: disabled, backDisabled: disabled }),
  setProgressBarStep: (stepNumber) => set({ progressBarStep: stepNumber }),
}))
